import { Button, Group, RichCell, SimpleCell, Text } from '@vkontakte/vkui';
import { UserAvatar } from '../../components/UserAvatar';
import { useAppContext } from '../../../AppContext';
import PropTypes from 'prop-types';
import { CreatorType, CreditorTypeV4 } from '../../../Types';

export const CreditRowComponent = ({panel, userId, creditors, members, onClickAddRepayment, createRepaymentButtonMode}) => {
  const debtorUser = members[userId];

  return (<RichCell
    multiline
    before={<UserAvatar size={48} type={debtorUser.type} src={debtorUser.img} name={debtorUser.name} id={debtorUser.id} url={debtorUser.link || undefined} />}
    actions={<CreditUsersComponent panel={panel} userId={userId} users={creditors} members={members} onClickAddRepayment={onClickAddRepayment} createRepaymentButtonMode={createRepaymentButtonMode}/>}
    disabled
  >
    {debtorUser.name}
  </RichCell>);
}

CreditRowComponent.propTypes = {
  panel: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  creditors: PropTypes.arrayOf(CreditorTypeV4).isRequired,
  members: PropTypes.objectOf(CreatorType).isRequired,
  onClickAddRepayment: PropTypes.func.isRequired,
};

export const DebtorRowComponent = ({panel, user, amount, onClickButton, buttonMode = 'outline'}) => {
  const context = useAppContext();

  return (<RichCell
    multiline
    before={<UserAvatar size={48} type={user.type} src={user.img} name={user.name} id={user.id} url={user.link || undefined} />}
    actions={<Button
      size="s"
      mode={buttonMode}
      align="left"
      onClick={() => onClickButton()}
    >
      {context.lang().getKey(panel, 'add_repayment')}
    </Button>}
    after={context.lang().formatPrice(amount)}
    disabled
  >
    {user.name}
  </RichCell>);
}

DebtorRowComponent.propTypes = {
  panel: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  amount: PropTypes.number,
  onClickButton: PropTypes.func.isRequired,
  buttonMode: PropTypes.string,
};

const CreditUsersComponent = ({panel, userId, users, members, onClickAddRepayment, createRepaymentButtonMode = () => false}) => {
  const context = useAppContext();

  return (<Group className={'CreditorRow__usersBlock'}>
    {
      users.map((row) => {
        const user = members[row.creditor_id === userId ? row.debtor_id : row.creditor_id];

        return (<SimpleCell
          disabled
          key={'debtor' + row.debtor_id + 'creditor' + row.creditor_id}
          className={'CreditorRow__userRow'}
          before={<UserAvatar
            size={38}
            type={user.type}
            src={user.img}
            name={user.name}
            id={user.id}
            url={user.link}
          />}
          after={<Text weight={'3'} className={'CreditorRow__userRowRightBlock'}>
            {row.amount < 0 ? ('+' + context.lang().formatPrice(row.amount * -1)) : (context.lang().formatPrice(row.amount))}
          </Text>}
          subtitle={
            <Button
              size="s"
              mode={createRepaymentButtonMode(row) ? 'primary' : 'outline'}
              align={'left'}
              onClick={() => onClickAddRepayment(row.creditor_id, row.debtor_id)}
            >
              {context.lang().getKey(panel, 'add_repayment')}
            </Button>
          }
        >
          {user.name}
        </SimpleCell>);
      })
    }
  </Group>);
}

CreditUsersComponent.propTypes = {
  panel: PropTypes.string.isRequired,
  users: PropTypes.arrayOf(CreditorTypeV4).isRequired,
  members: PropTypes.objectOf(CreatorType).isRequired,
  onClickAddRepayment: PropTypes.func.isRequired,
  createRepaymentButtonMode: PropTypes.func,
};
